<script>
  import { _ as t } from "svelte-i18n";

  import InLineInput from "./InLineInput.svelte";

  export let data;
  export let errors;
</script>

<p class="conversation">
  {$t("conversation.iam")}
  <InLineInput
    bind:value={data.firstName}
    label={$t("data.firstName")}
    error={errors["first_name"]}
  />
  <InLineInput bind:value={data.lastName} label={$t("data.lastName")} />
  {$t("conversation.born")}
  <InLineInput
    bind:value={data.birthDate}
    label={$t("data.birthDate")}
    type="date"
  />
  {$t("conversation.where")}
  <InLineInput bind:value={data.birthPlace} label={$t("data.birthPlace")} />
  {$t("conversation.province")}
  <InLineInput bind:value={data.birthState} label={$t("data.birthState")} />
  (
  <InLineInput bind:value={data.birthCountry} label={$t("data.birthCountry")} />
  ) .
</p>
<p class="conversation">
  {$t("conversation.ssn")}
  <InLineInput
    bind:value={data.fiscalCode}
    label={$t("data.fiscalCode")}
    long
  />
  {$t("conversation.residence")}
  <InLineInput bind:value={data.address} label={$t("data.address")} />
  ,
  <InLineInput bind:value={data.zipCode} label={$t("data.zipCode")} />
  <InLineInput bind:value={data.city} label={$t("data.city")} />
  {$t("conversation.province")}
  <InLineInput bind:value={data.state} label={$t("data.state")} />
  <span style="display: inline-block">
    (
    <InLineInput bind:value={data.country} label={$t("data.country")} />
    ).
  </span>
</p>

<style>
  p {
    margin: 48px 0 0;
    font-size: 14px;
  }

  .conversation {
    font-size: 16px;
    letter-spacing: 0.03rem;
    color: var(--gray-color);
  }

  @media only screen and (min-width: 600px) {
    .conversation {
      font-size: 22px;
      letter-spacing: 0.03rem;
      color: var(--gray-color);
    }
  }
</style>
